export default "__VITE_ASSET__8eb28184__"